import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Link, Switch, Route } from 'react-router-dom';
import Home from './Home';
import Post from './Post';


class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <header className="App-header">
            <Link to="/">
              <img src={logo} className="App-logo" alt="logo"/>
            </Link>
            <h1 className="App-title">Welcome!</h1>
            <Link to="/">Home</Link> <Link to="/Post/">Post</Link>
          </header>
          <Switch>
            <Route exec path="/" component={Home} />
            <Route path="/post/" component={Post} />
          </Switch>
        </div>
      </BrowserRouter>
    )
  }
}

export default App;
